import { render, staticRenderFns } from "./Descuento_1.vue?vue&type=template&id=65499cae&scoped=true&"
import script from "./Descuento_1.vue?vue&type=script&lang=js&"
export * from "./Descuento_1.vue?vue&type=script&lang=js&"
import style0 from "./Descuento_1.vue?vue&type=style&index=0&id=65499cae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65499cae",
  null
  
)

export default component.exports